module.exports = __webpack_public_path__ + "img/87.fddbae13.jpg";